<template>
  <div class="create-acivity">
    <div class="acivity-right">
      <div style="width: 100%;height: 100%;">
        <div>
          <el-form :inline="false" class="acivity-content-form" ref="formInline" :model="addDateArr" :rules="rules"
            label-width="120px">
            <el-form-item label="活码名称：" prop="name">
              <el-input @input="changeNameCount" v-model="addDateArr.name" placeholder="请输入活码名称（不能超过30字）" maxlength="30"
                :disabled="isdisable"></el-input>
              <span class="codeCount">{{count}}/30</span>
            </el-form-item>
            <el-form-item label="上传二维码：" prop="qrCodeList">
              <div class="secondCode">
                <div @click="toCodeAdd(1)" :class="isdisable?'':'updateCodeClass'">+上传二维码</div>
                <div>
                  <el-table :data="qrCodeList" class="table activityCodeTable codeTable1" style="margin: 0"
                    row-key="sort">
                    <el-table-column prop="name" label="子码名称">
                      <template slot-scope="scope">
                        {{ scope.row.name }}
                      </template>
                    </el-table-column>
                    <el-table-column label="二维码">
                      <template slot-scope="scope">
                        <img :src="scope.row.qrcodeUrl" :preview="scope.row.qrcodeUrl" preview-text="" width="30px"
                          class="yl">
                        <!-- <qriously :value="scope.row.lottery_url" :size="100" style="margin-left: px;" /> -->
                        <!-- <img @click="showQRcode(scope.row.qrcodeUrl)" :src="scope.row.qrcodeUrl" width="30px"> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="扫码上限">
                      <template slot-scope="scope">
                        {{scope.row.dayLimit}}
                      </template>
                    </el-table-column>
                    <el-table-column label="当日扫码次数" prop="curdayNumber">
                    </el-table-column>
                    <el-table-column label="累计扫码次数" prop="number">
                    </el-table-column>
                    <el-table-column label="操作" width="160" v-if="!isdisable">
                      <template slot-scope="scope">
                        <div class="op-link" @click="toEditCode(scope.$index, scope.row,1)">
                          编辑
                        </div>
                        <div class="op-link" @click="toDeleteCode(scope.$index, scope.row,1)">
                          删除
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="二维码切换：">
              <el-radio-group v-model="addDateArr.type" @change="pageStyleChange" :disabled="isdisable"
                class="activityCodeBox" style="padding-top: 12px">
                <div style="margin-bottom: 15px">
                  <el-radio :label="1">按顺序切换
                    <div style="color: #AAAAAA;padding: 10px 23px;">单张二维码达到扫码上限后自动切换到下一张</div>
                  </el-radio>
                </div>
                <div>
                  <el-radio :label="0">随机切换
                    <div style="color: #AAAAAA;padding: 10px 23px">所有上传二维码随机展示，分散短时间内单张二维码扫码压力</div>
                  </el-radio>
                </div>

              </el-radio-group>
            </el-form-item>
            <el-form-item label="客服二维码：">
              <div class="secondCode">
                <div class="">如上传客服二维码，将在活码页底部显示联系活动方，个别无法扫码进群的可通过加客服为好友邀请进群，客服码将随机分配</div>
                <div @click="toCodeAdd(2)" :class="isdisable?'':'updateCodeClass'">+上传客服二维码</div>
                <div>
                  <el-table :data="serviceCodeList" class="table activityCodeTable codeTable2" style="margin: 0"
                    row-key="sort">
                    <el-table-column prop="name" label="客服名称">
                      <template slot-scope="scope">
                        {{ scope.row.name }}
                      </template>
                    </el-table-column>
                    <el-table-column label="二维码">
                      <template slot-scope="scope">
                        <img :src="scope.row.qrcodeUrl" :preview="scope.row.qrcodeUrl" preview-text="" width="30px"
                          class="yl">
                        <!-- <qriously :value="scope.row.lottery_url" :size="100" style="margin-left: px;" /> -->
                        <!-- <img @click="showQRcode(scope.row.qrcodeUrl)" :src="scope.row.qrcodeUrl" width="30px"> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="每日扫码上限">
                      <template slot-scope="scope">
                        {{scope.row.dayLimit}}
                      </template>
                    </el-table-column>
                    <el-table-column label="当日扫码次数" prop="curdayNumber">
                    </el-table-column>
                    <el-table-column label="累计扫码次数" prop="number">
                    </el-table-column>
                    <el-table-column label="操作" width="160" v-if="!isdisable">
                      <template slot-scope="scope">
                        <div class="op-link" @click="toEditCode(scope.$index, scope.row,2)">
                          编辑
                        </div>
                        <div class="op-link" @click="toDeleteCode(scope.$index, scope.row,2)">
                          删除
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="重复扫码：">
              <el-checkbox class="activityCodeBox" disabled text-color="#1890FF" v-model="checked"
                @change="changeQrCode">同一用户重复扫码展示相同二维码</el-checkbox>
            </el-form-item>
            <el-form-item class="button-content" v-if="!isdisable">
              <span class="saveOne" style="margin-right: 30px;width: 110px" type="primary"
                @click="saveWay('1')">保存并启用</span>
              <span class="saveScond" style="width: 110px" @click="saveWay('0')">保存不启用</span>
            </el-form-item>
          </el-form>
          <div style="text-align: center;width: 260px;margin: 0 auto;height: 36px">
            <!--                        <el-button class="dialog-confirm-btn" type="primary" style="float: left;" >保存不启用</el-button>-->
          </div>
        </div>
      </div>
    </div>
    <!--      新增二维码弹框-->
    <el-dialog class="cellDialog base-dialog live-code-dialog" title="二维码" :visible.sync="addQrCodedialog"
      width="780px">
      <el-form :inline="false" class="acivity-content-form" ref="formInlineAdd" :model="addCodeArr" :rules="rules1"
        label-width="100px">
        <el-form-item label="二维码图片：" prop="qrcodeUrl" style="" class="qrcodeUrl-code live-code-qrcodeUrl">
          <el-upload class="avatar-uploader" v-show="isShowUpload" name="file_upload" list-type="picture-card"
            :file-list="fileUrl" :action="uploadURL" multiple :on-success="handleAvatarSuccess"
            :on-remove="handleAvatarMove" :before-upload="beforeAvatarUpload" ref="upload"
            :class="{hide:hideUploadEdit}">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="子码名称：" v-show="isShowZMName">
          <div style="display: flex;justify-content: left">
            <el-input v-if="codeType == 1" @input="changeNameCount1" v-model="addCodeArr.name"
              placeholder="请输入子码名称（不能超过30字）" maxlength="30">
            </el-input>
            <el-input v-if="codeType == 2" @input="changeNameCount1" v-model="serviceCodeArr.name"
              placeholder="请输入子码名称（不能超过30字）" maxlength="30">
            </el-input>
            <span class="codeCount">{{count1}}/30</span>
          </div>
        </el-form-item>
        <el-form-item label="扫码上限：" prop="dayLimit">
          <el-input type="number" min="0" v-if="codeType == 1" v-model="addCodeArr.dayLimit" placeholder="请输入扫码上限">
          </el-input>
          <el-input type="number" min="0" v-if="codeType == 2" v-model="serviceCodeArr.dayLimit" placeholder="请输入扫码上限">
          </el-input>
          <div v-if="codeType == 1"
            style="font-size: 12px;line-height: 40px;display: flex;justify-content: left;align-items: center"> <img
              class="smImg" src="../../assets/images/card-ticket/Shape.png">
            <span style="padding-left: 5px;">微信官方限制，扫描微信二维码进群人数上限为200人 </span>
          </div>
        </el-form-item>
        <div class="" style="margin-top: 60px;display: flex;justify-content: center">
          <el-button class="dialog-cancel-btn" @click="cancleAttr" style="margin-right: 20px">取 消</el-button>
          <el-button class="dialog-confirm-btn" type="primary" @click="confirmAddAttr(codeType)">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--添加二维码分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="qrCodedialog" width="620px">
      <el-input id="copyObj" class="qrcode-show-input" type="text" v-model.trim="qrCodeUrl" auto-complete="off"
        placeholder=""></el-input>
      <el-button class="dialog-confirm-btn" @click="getUrl" style="margin-left: 15px;color: #fff">复制链接</el-button>
      <!--<p style="word-break:break-all;">-->
      <!--{{ qrCodeUrl }}-->
      <!--</p>-->
      <qriously :value="qrCodeUrl" :size="240" />
      <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
              <el-button class="dialog-cancel-btn" @click="qrCodedialog = false" style="margin-left: 20px">关 闭</el-button>
            </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { addNimbleCode, updateNimbleCode } from '@/api/analyse.js'
import Sortable from 'sortablejs'

export default {
  name: 'add-activity',
  data () {
    var validatePhone = (rule, value, callback) => {
      if (this.qrCodeList.length == 0) {
        return callback(new Error('请上传子码信息'))
      } else {
        return callback()
      }
    }
    var validatecstm = (rule, value, callback) => {
      if (this.serviceCodeList.length == 0) {
        return callback(new Error('请上传客服二维码信息'))
      } else {
        return callback()
      }
    }
    var validateDayLimit = (rule, value, callback) => {
      if (this.addCodeArr.dayLimit > 100000000) {
        return callback(new Error('扫码上限要小于8位数'))
      } else {
        return callback()
      }
    }
    return {
      isdisable: false,
      addQrCodedialog: false,
      count: 0,
      count1: 0,
      checked: true,
      tableData: [{ name: 111 }],
      qrCodedialog: false,
      qrCodeUrl: '',
      addDateArr: {
        description: '',
        name: '',
        status: '', // 活码状态,0-禁用，1-启用
        type: 1, // 切换二维码类型，0-随机，1-顺序
        usrRepeatScan: 1, // 同一用户重复扫展示相同二维码,0-否，1-是
        qrCodeList: [],
        cstmQrCodeList: []
      },
      id: '',
      isadd: true,
      isSave: true,
      isEditIndex: 0,
      qrCodeList: [],
      addCodeArr: {
        dayLimit: 200,
        name: '',
        qrcodeUrl: [],
        curdayNumber: 0,
        number: 0,
        sort: 0,
        codeType: 1
      },
      addCodeArrtmp: {
        dayLimit: 200,
        name: '',
        qrcodeUrl: ''
      },
      isaddList: false,
      rules1: {
        qrcodeUrl: [
          { required: true, message: '请上传二维码图片', trigger: 'blur' }
        ],
        dayLimit: [
          { required: false, validator: validateDayLimit, trigger: 'blur' }
        ],
      },
      rules: {
        name: [
          { required: true, message: '请输入活码名称', trigger: 'blur' }
        ],
        qrCodeList: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        cstmQrCodeList: [
          { required: true, validator: validatecstm, trigger: 'blur' }
        ]
      },
      dialogImageUrl: '',
      dialogVisible: false,
      uploadFiles: [],
      isShowZMName: false,
      serviceCodeList: [],
      serviceCodeArr: {
        dayLimit: 200,
        name: '',
        qrcodeUrl: '',
        curdayNumber: 0,
        number: 0,
        sort: 0,
        codeType: 2
      },
      codeType: 1,
      uploadFileNames: [],
      fileUrl: [],
      hideUploadEdit: false,
      isSort: false,
      isShowUpload: true
    }
  },
  methods: {
    cancleAttr () {
      // this.qrCodeList[this.isEditIndex] = this.addCodeArrtmp
      this.addQrCodedialog = false
      this.fileUrl = []
      this.isShowUpload = false
    },
    toEditCode (index, row, type) {
      this.fileUrl = []
      this.isadd = false
      this.isaddList = true
      this.isShowZMName = true
      this.addQrCodedialog = true
      this.codeType = type
      this.hideUploadEdit = true
      this.count1 = row.name.length
      // this.addCodeArrtmp = Object.assign({}, this.qrCodeList[index])
      if (type == 1) {
        this.addCodeArr = {
          id: row.id,
          dayLimit: row.dayLimit,
          qrcodeUrl: row.qrcodeUrl,
          name: row.name,
          curdayNumber: row.curdayNumber || 0,
          number: row.number || 0,
          codeType: row.codeType || 1,
          sort: row.sort || 0
        }
      } else {
        this.serviceCodeArr = {
          id: row.id,
          dayLimit: row.dayLimit,
          qrcodeUrl: row.qrcodeUrl,
          name: row.name,
          curdayNumber: row.curdayNumber || 0,
          number: row.number || 0,
          codeType: row.codeType || 2,
          sort: row.sort || 0
        }
      }
      this.fileUrl.push({
        name: row.name,
        url: row.qrcodeUrl
      })
      this.isEditIndex = index
      this.isShowUpload = true
    },
    toDeleteCode (index, row, type) {
      let newList = []
      if (type == 1) {
        this.qrCodeList.map(function (item, index1) {
          if (index1 !== index) {
            newList.push(item)
          }
        })
        this.qrCodeList = newList
      } else {
        this.serviceCodeList.map(function (item, index1) {
          if (index1 !== index) {
            newList.push(item)
          }
        })

        this.serviceCodeList = newList
      }
    },
    toCodeAdd (type) {
      this.fileUrl = []
      if (!this.isdisable) {
        // if(this.qrCodeList.length>50) {
        //   _g.toastMsg('error', '最多可设置50个子码')
        // } else {
        this.isadd = true
        this.isaddList = true
        this.isShowZMName = false
        this.addQrCodedialog = true
        this.codeType = type
        this.hideUploadEdit = false
        this.addCodeArr = {
          dayLimit: 200,
          name: '',
          qrcodeUrl: [],
          curdayNumber: 0,
          number: 0,
          codeType: 1,
          sort: 0
        }
        this.serviceCodeArr = {
          dayLimit: 200,
          name: '',
          qrcodeUrl: [],
          curdayNumber: 0,
          number: 0,
          codeType: 1,
          sort: 0
        }
        this.uploadFileNames = []
        this.uploadFiles = []
        this.isShowUpload = true
      }
    },
    confirmAddAttr (type) {
      let that = this
      if (type == 1) {
        that.isaddList = false
        this.addQrCodedialog = false
        if (this.isadd) { // tianjia
          for (let item in this.uploadFileNames) {
            this.qrCodeList.push({
              dayLimit: this.addCodeArr.dayLimit,
              name: this.uploadFileNames[item],
              qrcodeUrl: this.uploadFiles[item],
              curdayNumber: 0,
              number: 0,
              sort: this.qrCodeList.length,
              codeType: 1
            })
          }
          this.$previewRefresh()
        } else { // bianji
          this.qrCodeList[that.isEditIndex].dayLimit = that.addCodeArr.dayLimit
          this.qrCodeList[that.isEditIndex].name = that.addCodeArr.name
          this.qrCodeList[that.isEditIndex].qrcodeUrl = that.addCodeArr.qrcodeUrl
          this.qrCodeList[that.isEditIndex].curdayNumber = that.addCodeArr.curdayNumber
          this.qrCodeList[that.isEditIndex].number = that.addCodeArr.number
          this.qrCodeList[that.isEditIndex].sort = that.addCodeArr.sort
          this.qrCodeList[that.isEditIndex].codeType = that.addCodeArr.codeType
          this.$forceUpdate()
          this.$nextTick(() => {

          })
        }
      } else {
        that.isaddList = false
        this.addQrCodedialog = false
        if (this.isadd) { // tianjia
          for (let item in this.uploadFileNames) {
            this.serviceCodeList.push({
              dayLimit: this.serviceCodeArr.dayLimit,
              name: this.uploadFileNames[item],
              qrcodeUrl: this.uploadFiles[item],
              curdayNumber: 0,
              number: 0,
              sort: this.serviceCodeList.length,
              codeType: 2
            })
          }
          this.$previewRefresh()
        } else { // bianji
          this.serviceCodeList[that.isEditIndex].dayLimit = that.serviceCodeArr.dayLimit
          this.serviceCodeList[that.isEditIndex].name = that.serviceCodeArr.name
          this.serviceCodeList[that.isEditIndex].qrcodeUrl = that.serviceCodeArr.qrcodeUrl
          this.serviceCodeList[that.isEditIndex].curdayNumber = that.serviceCodeArr.curdayNumber
          this.serviceCodeList[that.isEditIndex].number = that.serviceCodeArr.number
          this.serviceCodeList[that.isEditIndex].sort = that.serviceCodeArr.sort
          this.serviceCodeList[that.isEditIndex].codeType = that.serviceCodeArr.codeType
          this.$forceUpdate()
          this.$nextTick(() => {

          })
        }
      }
      this.isShowUpload = false
      this.$refs.upload.clearFiles()
      this.fileUrl = []
      this.isShowUpload = false
    },
    // 点击保存
    saveWay (status) {
      this.serviceCodeList.forEach((item, index) => {
        item.sort = index
      })
      this.qrCodeList.forEach((item, index) => {
        item.sort = index
      })
      this.addDateArr.qrCodeList = this.qrCodeList
      this.addDateArr.cstmQrCodeList = this.serviceCodeList
      let that = this
      this.$refs['formInline'].validate((valid) => {
        if (valid && that.isSave) {
          that.isSave = false
          this.addDateArr.status = status
          if (this.$route.query.type === 'add') {
            this.addNimbleCode()
          } else {
            this.updateNimbleCode()
          }

        }
      })
    },
    addNimbleCode () {
      this.addDateArr.status = JSON.parse(this.addDateArr.status)
      addNimbleCode(this.addDateArr).then(res => {
        if (res.data.code == 200) {
          this.$router.back()
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
        this.isSave = true
      })
    },
    updateNimbleCode () {
      this.addDateArr.status = JSON.parse(this.addDateArr.status)
      this.addDateArr.id = this.id
      this.addDateArr.qrCodeList = this.qrCodeList
      this.addDateArr.cstmQrCodeList = this.serviceCodeList
      updateNimbleCode(this.addDateArr).then(res => {
        if (res.data.code == 200) {
          this.$router.back()
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
        this.isSave = true
      })
    },
    // 计算活动数量
    changeNameCount (val) {
      this.count = val.length
    },
    changeNameCount1 (val) {
      this.count1 = val.length
    },
    // 改变选择
    changeQrCode (val) {
      if (val) {
        this.addDateArr.usrRepeatScan = 1
      } else {
        this.addDateArr.usrRepeatScan = 0
      }
    },
    handleAvatarSuccess (res, file) {
      if (this.isadd == false) {
        this.hideUploadEdit = true
        if (this.codeType == 1) {
          this.addCodeArr.qrcodeUrl = res.data.path
        } else {
          this.serviceCodeArr.qrcodeUrl = res.data.path
        }
      } else {
        this.uploadFiles.push(res.data.path)
        this.addCodeArr.qrcodeUrl = this.uploadFiles
      }
    },
    beforeAvatarUpload (file) {
      this.uploadFileNames.push(file.name)
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    handleAvatarMove (file, fileList) {
      this.uploadFiles = []
      this.uploadFileNames = []
      fileList.forEach(item => {
        this.uploadFiles.push(item.url)
        this.uploadFileNames.push(item.name)
      })
      this.addCodeArr.qrcodeUrl = this.uploadFiles
      if (this.isadd == false) {
        this.fileUrl = []
        this.hideUploadEdit = false
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 获取二维码地址
    getUrl () {
      let url = document.querySelector('#copyObj')
      url.select() // 选择对象
      document.execCommand('Copy')
    },
    showQRcode (url) {
      this.qrCodedialog = true
      this.qrCodeUrl = url
    },
    pageStyleChange () {
    },
    // 行拖拽
    rowDrop () {
      const tbody = document.querySelector('.codeTable1 tbody')
      this.sortable = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        onEnd: evt => {
          const oldItem = this.qrCodeList.splice(evt.oldIndex, 1)[0]
          this.$nextTick(() => {
            this.qrCodeList.splice(evt.newIndex, 0, oldItem)
          })
        }
      })
    },
    serviceDrop () {
      const tbody = document.querySelector('.codeTable2 tbody')
      this.sortable = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        onEnd: evt => {
          const oldItem = this.serviceCodeList.splice(evt.oldIndex, 1)[0]
          this.$nextTick(() => {
            this.serviceCodeList.splice(evt.newIndex, 0, oldItem)
          })
        }
      })
    }
  },
  watch: {
    addQrCodedialog: {
      handler (newVal, oldVal) {
        if (newVal == false) {
          this.fileUrl = []
          this.isShowUpload = false
        }
      }
    }
  },
  mounted () {
    this.rowDrop()
    this.serviceDrop()
  },
  computed: {
    uploadURL () {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created () {
    if (this.$route.query.type === 'edit' || this.$route.query.type === 'detail') {
      if (this.$route.query.type === 'detail') {
        this.isdisable = true
      } else {
        this.isdisable = false
      }
      let arrInfo = JSON.parse(this.$route.query.row)
      let newlist = []
      let cstmList = []
      arrInfo.qrCodeList.map(function (item, index) {
        newlist.push({
          id: item.id,
          dayLimit: item.dayLimit,
          qrcodeUrl: item.qrcodeUrl,
          cstmQrCodeList: item.cstmQrCodeList,
          name: item.name,
          curdayNumber: item.curdayNumber,
          number: item.number,
          sort: item.sort,
          codeType: item.codeType
        })
      })
      arrInfo.cstmQrCodeList.map(function (item, index) {
        cstmList.push({
          id: item.id,
          dayLimit: item.dayLimit,
          qrcodeUrl: item.qrcodeUrl,
          name: item.name,
          curdayNumber: item.curdayNumber,
          number: item.number,
          sort: item.sort,
          codeType: item.codeType
        })
      })
      this.count = arrInfo.name.length
      this.addDateArr = {
        description: '',
        name: arrInfo.name,
        status: arrInfo.status, // 活码状态,0-禁用，1-启用
        type: arrInfo.type, // 切换二维码类型，0-随机，1-顺序
        usrRepeatScan: arrInfo.usrRepeatScan, // 同一用户重复扫展示相同二维码,0-否，1-是
        qrCodeList: newlist,
        cstmQrCodeList: cstmList
      }
      if (arrInfo.usrRepeatScan == 0) {
        this.checked = false
      } else {
        this.checked = true
      }
      this.id = arrInfo.id
      this.qrCodeList = newlist
      this.serviceCodeList = cstmList
    }
  }
}
</script>

<style scoped>
.saveScond {
  height: 36px;
  border-radius: 4px;
  background: #1980ff;
  color: #fff;
  font-family: PingFang SC;
  padding: 7px 17px;
  font-size: 14px;
  margin-top: 3px;
  cursor: pointer;
}
.saveOne {
  height: 36px;
  border-radius: 4px;
  color: #666;
  font-family: PingFang SC;
  padding: 7px 17px;
  font-size: 14px;
  margin-top: 3px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
}
.updateCodeClass {
  color: #1890FF;
  cursor: pointer;
}
.addImg {
  cursor: pointer;
  font-size: 20px;
  color: #808080;
  text-align: center;
  line-height: 75px;
  width: 80px;
  height: 80px;
  background-color: #f2f2f2;
}
.acivity-right {
  width: 95%;
}
.table {
  border: 1px solid #e8e8e8;
}
.codeCount {
  margin-left: 10px;
}
.create-acivity {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  padding: 40px 0px;
  overflow-x: hidden;
}
.mobile-img {
  position: absolute;
}
.scrol-image {
  /*margin-left: 130px;*/
}
.liuhai {
  position: absolute;
  top: 113px;
  z-index: 100;
}
.scrol-image,
.scrol-image .el-carousel__item {
  height: 575px;
  width: 266px;
  border-radius: 26px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.tab-tit {
  width: 394px;
  margin: 90px auto 0;
  margin-bottom: 20px;
  overflow: hidden;
}
.tab-tit .cur {
  background: #1890FF;
  color: #fff;
}

.tab-tit .line,
.saveData .line {
  width: 90%;
  margin: 2% auto;
  border: 0.5px dashed #d2d2d2;
}
.tab-tit a {
  cursor: pointer;
  display: block;
  float: left;
  width: 130px;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  text-align: center;
  background: #fff;
  color: #333;
  border: 1px solid #1890FF;
}
.acivity-content-form {
  /*width: 460px;*/
  text-align: left;
  margin: auto;
}
.acivity-setting-form {
  /*width: 460px;*/
  text-align: center;
  margin: auto;
}
.acivity-prize-form {
  /*text-align: center;*/
  /*margin: 0 auto;*/
  width: 100%;
}
.acivity-content-form .el-form-item__content {
  width: 300px;
}
.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.prize-count {
  width: 100px;
}
.prize-count-special {
  width: 160px;
}
.prize-percent {
  width: 80px;
}
.prize-percent .el-input {
  width: 60px;
}
.prize-percent .el-input__inner {
  width: 60px;
  height: 36px;
}
.home-pic {
  width: 100%;
  height: 100%;
}
.avatar-pic {
  height: 80px;
  width: 80px;
  display: block;
}
.button-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 60px;
}
.new-add-setting {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.new-add-table {
  width: 100%;
  margin-top: 40px;
}
.tags-text-item {
  width: 200px;
}
@media screen and (min-width: 1600px) {
  .acivity-left {
    width: 35%;
    justify-content: flex-end;
    margin-right: 100px;
  }
  .mobile-img {
    right: -23px;
  }
  .liuhai {
    right: 60px;
  }
}
.yl {
  cursor: pointer;
}
</style>
